module.exports = __webpack_public_path__ + "img/keder_brillantgelb_farbnr119.74ef8683.jpg";